import { LegalTextWithLink } from '../../molecules/LegalTextWithLink';
import { PrivacyRightsStatementSectionProps } from './PrivacyRightsWrapper.types';

export const PrivacyRightsStatementSection = ({
  checkboxes,
  statementHeaderForGPC,
  statementTitle,
  instructions,
}: PrivacyRightsStatementSectionProps) => {
  return (
    <>
      {statementHeaderForGPC && (
        <div className="mb-4">
          <h6 data-testid="privacy-rights-GPC-header">{statementHeaderForGPC}</h6>
        </div>
      )}

      {checkboxes.length > 0 && (
        <>
          <span className="t-font-m" data-testid="privacy-rights-statement-title">
            {statementTitle}
          </span>
          <ul className="pl-4">
            {checkboxes.map(checkbox =>
              checkbox?.statementLabel ? (
                <li key={checkbox.uniqueId}>
                  <span className="t-font-m">{checkbox?.statementLabel}</span>
                </li>
              ) : null
            )}
          </ul>
        </>
      )}

      {instructions.map(item => (
        <LegalTextWithLink key={item.uniqueId} descriptionText={item.description} />
      ))}
    </>
  );
};
